//WLFORUM OPERATOR

import en_US from '../../en_US';

const extend = {
  speakers: 'Speakers',
  live: 'Live'
};

const en_WLFORUM = {...en_US, ...extend};

export default en_WLFORUM;



// WEBPACK FOOTER //
// ./src/locales/dics/ext/wlforum/en_WLFORUM.js